var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pie-chart',{attrs:{"labels":['Kernel', 'Used', 'Free' ],"values":_vm.ramValues,"colors":['#AAA', '#2196F3', '#4CAF50']}})}
var staticRenderFns = []

export { render, staticRenderFns }